import pluralize from 'pluralize';

export const LABELS_SELECT_LABELS = {
	DEFAULT_PLACEHOLDER: 'Select an option',
	DEFAULT_ARIA_LABEL: 'Select dropdown',
	getSomeItemsSelectedText: (ariaLabel: string, numberOfItems: number): string =>
		`${pluralize(ariaLabel, numberOfItems, true)} (${numberOfItems})`,
	getAllSelectedPlaceholder: (ariaLabel: string, optionsCount: number): string =>
		`All ${pluralize(ariaLabel, optionsCount)}`
} as const;
